import styles from './index.module.scss';
import { useEffect, useState } from 'react'
import { hotResourceList } from '@/apis/discover.js';
import ResourceCard from '@/components/ResourceCard';
import intl from "react-intl-universal";

const HotResource = () => {
	const [hotList, setHotList] = useState([]);
	const getList = () => {
		hotResourceList({
			limit: 6
		}).then(res => {
			setHotList(res.data)
		})
	}
	useEffect(() => {
		getList()
	}, [])


	const updateData = (id, flag) => {
		setHotList(hotList.map(item => {
			if (item.resourceUuid === id) {
				return {
					...item,
					isFavorite: flag,
					collectTimes: flag ? item.collectTimes + 1 : item.collectTimes - 1
				}
			} else {
				return item
			}
		}))
	}

	return <div className='container'>
		<h1 className={styles.h1Box}>{intl.get("Hot Resources")}</h1>
		<div className={styles.contentBox}>
			{
				hotList.map(item => <ResourceCard data={item} rows={2} changeData={updateData} isShowView/>)
			}
		</div>
	</div>
}
export default HotResource;